import Urus from '../assets/realisations/f_car.webp'; //Lamborghini Urus
import Cayman from '../assets/realisations/se_car.webp'; //Porsche 718 Cayman
import Benz from '../assets/realisations/th_car.webp'; //Mercedes-Benz Classe CLA
import Macan from '../assets/realisations/fou_car.webp'; //Porsche Macan
import RS from '../assets/realisations/fir_car.webp'; //2015 Audi RS6
import R from '../assets/realisations/si_car.webp'; //2008 Audi R8
import GT from '../assets/realisations/sev_car.webp'; //BMW M3 GT2
import Rover from '../assets/realisations/hei_car.webp'; //Land Rover

const realisations = [
    {
        id: 1,
        title: "Lamborghini",
        cover: Urus,
        alt: "Lamborghini Urus"
    }, {
        id: 2,
        title: "Cayman",
        cover: Cayman,
        alt: "Porsche 718 Cayman"
    }, {
        id: 3,
        title: "Mercedes",
        cover: Benz,
        alt: "Mercedes-Benz Classe CLA"
    }, {
        id: 4,
        title: "Macan",
        cover: Macan,
        alt: "Porsche Macan"
    }, {
        id: 5,
        title: "RS6",
        cover: RS,
        alt: "2015 Audi RS6"
    }, {
        id: 6,
        title: "R8",
        cover: R,
        alt: "2008 Audi R8"
    }, {
        id: 7,
        title: "GT2",
        cover: GT,
        alt: "BMW M3 GT2"
    }, {
        id: 8,
        title: "Rover",
        cover: Rover,
        alt: "Land Rover"
    }
]
export default realisations;

